// ===============================
// pages/Cart.jsx
// ===============================

import React, {
  useContext,
} from "react";

import {
  Link,
} from "react-router-dom";

import {
  CartContext,
} from "../../context/CartContext";

import "./Cart.css";

const Cart = () => {

  // ===============================
  // CONTEXT
  // ===============================

  const {
    cartItems,
    removeFromCart,
    increaseQty,
    decreaseQty,
    totalPrice,
  } = useContext(CartContext);

  return (
    <div className="cart-page">

      {/* ===============================
          HEADER
      =============================== */}

      <div className="cart-header">

        <div className="container">

          <h1>
            Your Shopping Cart
          </h1>

          <p>
            Review your selected items
          </p>

        </div>

      </div>

      {/* ===============================
          EMPTY CART
      =============================== */}

      {cartItems.length === 0 ? (

        <div className="empty-cart">

          <i className="fa-solid fa-cart-shopping"></i>

          <h2>
            Your Cart Is Empty
          </h2>

          <p>
            Looks like you haven’t
            added anything yet.
          </p>

          <Link
            to="/shop"
            className="shop-btn"
          >
            Continue Shopping
          </Link>

        </div>

      ) : (

        /* ===============================
            CART CONTENT
        =============================== */

        <div className="container cart-wrapper">

          {/* LEFT SIDE */}

          <div className="cart-items">

            {cartItems.map((item) => (

              <div
                className="cart-card"
                key={item._id}
              >

                {/* IMAGE */}

                <div className="cart-image">

                  <img
                    src={item.image}
                    alt={item.name}
                  />

                </div>

                {/* INFO */}

                <div className="cart-info">

                  <span className="cart-category">
                    {item.category}
                  </span>

                  <h3>
                    {item.name}
                  </h3>

                  <p className="cart-price">
                    ₹{
  Number(item.price) *
  Number(item.quantity || 1)
}
                  </p>

                  {/* QUANTITY */}

                  <div className="qty-box">

                    <button
                      onClick={() =>
                        decreaseQty(
                          item._id
                        )
                      }
                    >
                      -
                    </button>

                    <span>
                     {Number(item.quantity || 1)}
                    </span>

                    <button
                      onClick={() =>
                        increaseQty(
                          item._id
                        )
                      }
                    >
                      +
                    </button>

                  </div>

                </div>

                {/* RIGHT */}

                <div className="cart-right">

                  <h2>
                    ₹
                    {item.price *
                      item.quantity}
                  </h2>

                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(
                        item._id
                      )
                    }
                  >
                    Remove
                  </button>

                </div>

              </div>

            ))}

          </div>

          {/* ===============================
              SUMMARY
          =============================== */}

          <div className="cart-summary">

            <h2>
              Order Summary
            </h2>

            <div className="summary-row">

              <span>
                Total Items
              </span>

              <span>
                {cartItems.length}
              </span>

            </div>

            <div className="summary-row">

              <span>
                Shipping
              </span>

              <span>
                Free
              </span>

            </div>

            <div className="summary-row total">

              <span>
                Total
              </span>

              <span>
                ₹{totalPrice}
              </span>

            </div>

            <button className="checkout-btn">
              Proceed To Checkout
            </button>

          </div>

        </div>

      )}

    </div>
  );
};

export default Cart;